import React from "react";
import {
  Box,
  Typography,
  TextField,
  Paper,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
} from "@mui/material";
import SetupStepHelp from "./setup/SetupStepHelp";

const EtapaProdutos = ({
  showManualProductForm,
  setShowManualProductForm,
  manualProducts,
  newProduct,
  setNewProduct,
  handleAddManualProduct,
}) => {
  const theme = useTheme();

  const hasProducts = manualProducts?.length > 0;

  return (
    <Box sx={{ width: "100%"}}>
      <SetupStepHelp stepKey="products" />
      <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ color: theme.palette.primary.main }}>
        🧾 Cadastro de Produtos
      </Typography>

      <Typography variant="body1" gutterBottom>
        Agora vamos importar os produtos que você oferece. Isso vai ajudar o XPro a personalizar estratégias de vendas para seus diferentes tipos de clientes.
      </Typography>

      <Typography variant="body2" color="text.secondary">
        Você pode importar uma planilha, cadastrar manualmente ou pular essa etapa e concluir depois.
      </Typography>

      {!showManualProductForm && (
        <>
          <Paper
            elevation={1}
            sx={{
              border: "2px dashed #90caf9",
              backgroundColor: "#f5faff",
              padding: 4,
              mt: 3,
              textAlign: "center",
              cursor: "pointer",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "#e3f2fd",
                boxShadow: 2,
              },
            }}
          >
            <Typography variant="subtitle1" fontWeight="medium" gutterBottom>
              Arraste sua planilha aqui ou
            </Typography>
            <Button variant="contained" sx={{ mt: 1 }}>
              Selecionar Arquivo
            </Button>
            <Typography variant="caption" display="block" color="text.secondary" sx={{ mt: 2 }}>
              Formatos aceitos: .xlsx, .csv — Exemplo de colunas: Nome, Categoria, Preço
            </Typography>
            <Button variant="text" size="small" href="/modelo-produtos.xlsx" sx={{ mt: 1 }}>
              📎 Baixar modelo de planilha
            </Button>
          </Paper>
        </>
      )}

      {showManualProductForm && (
        <Box mt={4}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Cadastro Manual de Produtos
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Nome"
                value={newProduct.nome}
                onChange={(e) => setNewProduct({ ...newProduct, nome: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Categoria"
                value={newProduct.categoria}
                onChange={(e) => setNewProduct({ ...newProduct, categoria: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Preço"
                type="number"
                value={newProduct.preco}
                onChange={(e) => setNewProduct({ ...newProduct, preco: e.target.value })}
              />
            </Grid>
          </Grid>
          <Box mt={2} display="flex" gap={2}>
            <Button variant="contained" onClick={handleAddManualProduct}>Adicionar</Button>
          </Box>
        </Box>
      )}

    <Box mt={4} display="flex" flexWrap="wrap" gap={2}>
        <Button variant="outlined" onClick={() => setShowManualProductForm(!showManualProductForm)}>
            {showManualProductForm?"Importar planilha":"Cadastrar Manualmente"}
        </Button>
    </Box>

    {hasProducts && (
        <Box mt={4}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Produtos cadastrados:
            </Typography>
            <TableContainer component={Paper}>
            <Table size="small">
                <TableHead>
                <TableRow>
                    <TableCell>Nome</TableCell>
                    <TableCell>Categoria</TableCell>
                    <TableCell>Preço</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {manualProducts?.map((produto, index) => (
                    <TableRow key={index}>
                    <TableCell>{produto.nome}</TableCell>
                    <TableCell>{produto.categoria}</TableCell>
                    <TableCell>{produto.preco}</TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
            </TableContainer>
        </Box>
    )}
    </Box>
  );
};

export default EtapaProdutos;
